import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Eraser } from "lucide-react";
import { Button } from "./ui/button";

export const SignaturePad = forwardRef(function SignaturePad(_, ref) {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvas.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0b2c6b";
  }, []);

  const pos = (e) => {
    const r = canvas.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    drawing.current = true;
    canvas.current.setPointerCapture(e.pointerId);
    const ctx = canvas.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvas.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    setEmpty(false);
  };
  const clear = () => {
    const c = canvas.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
  };

  useImperativeHandle(ref, () => ({ toDataURL: () => canvas.current.toDataURL("image/png"), isEmpty: () => empty }), [empty]);

  return (
    <div className="space-y-2">
      <canvas ref={canvas} data-testid="signature-canvas" onPointerDown={down} onPointerMove={move} onPointerUp={() => { drawing.current = false; }}
        className="h-48 w-full touch-none rounded-xl border-2 border-dashed border-slate-300 bg-white" />
      <div className="flex items-center justify-between text-xs text-slate-400">
        <span>Signez dans le cadre avec le doigt ou un stylet</span>
        <Button type="button" size="sm" variant="ghost" data-testid="signature-clear-button" onClick={clear}><Eraser className="mr-1 h-4 w-4" />Effacer</Button>
      </div>
    </div>
  );
});
